import React from 'react';


export default function UrlScanInProgressListItem(props) {
    const { link } = props;
    
    return (
        <li className="list-group-item text-break">
            <h6 className="card-subtitle">
                <small className="text-muted" title={link.text}>{link.shortText}</small>
            </h6>
            <h5 className="card-title" title={link.href}>
                <small>{link.shortHref}</small>
            </h5>
            <div className="d-flex justify-content-center">
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span className="ml-2">Scanning in Progress...</span>
            </div>
        </li>
    );
}